import { useFlag } from '@/flags';

export function useSourceIndeedContract(): boolean {
  return useFlag('source-indeed-contract');
}
